import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      id: 'consulting',
      icon: 'ri-lightbulb-line',
      title: t('service1'),
      description: 'نقدم استشارات متخصصة لتطوير أعمالكم وتحقيق أهدافكم المؤسسية بكفاءة عالية',
      image: 'https://public.readdy.ai/ai/img_res/dedb4237991071999821171ab4bf4d46.jpg'
    },
    {
      id: 'planning',
      icon: 'ri-line-chart-line',
      title: t('service2'),
      description: 'نساعدكم في وضع خطط استراتيجية محكمة لتحقيق النمو المستدام والتميز المؤسسي',
      image: 'https://readdy.ai/api/search-image?query=strategic%20planning%20session%20with%20business%20charts%20and%20roadmap%20visualization%20in%20professional%20setting%20with%20simple%20clean%20background&width=600&height=400&seq=service-002&orientation=landscape'
    },
    {
      id: 'management',
      icon: 'ri-folder-chart-line',
      title: t('service3'),
      description: 'إدارة احترافية لمشاريعكم من البداية حتى التسليم مع ضمان الجودة والالتزام بالمواعيد',
      image: 'https://readdy.ai/api/search-image?query=project%20management%20workflow%20with%20team%20coordination%20and%20task%20organization%20in%20modern%20workspace%20with%20simple%20background&width=600&height=400&seq=service-003&orientation=landscape'
    },
    {
      id: 'development',
      icon: 'ri-building-line',
      title: t('service4'),
      description: 'تطوير شامل للهيكل المؤسسي والعمليات التشغيلية لتحسين الأداء والإنتاجية',
      image: 'https://readdy.ai/api/search-image?query=organizational%20development%20and%20business%20growth%20concept%20with%20modern%20corporate%20structure%20in%20clean%20professional%20environment&width=600&height=400&seq=service-004&orientation=landscape'
    },
    {
      id: 'training',
      icon: 'ri-graduation-cap-line',
      title: t('service5'),
      description: 'برامج تدريبية متخصصة لتأهيل الكوادر وتطوير المهارات المهنية والإدارية',
      image: 'https://readdy.ai/api/search-image?query=professional%20training%20workshop%20with%20instructor%20teaching%20business%20skills%20in%20modern%20training%20room%20with%20simple%20background&width=600&height=400&seq=service-005&orientation=landscape'
    },
    {
      id: 'research',
      icon: 'ri-file-search-line',
      title: t('service6'),
      description: 'دراسات وأبحاث معمقة لدعم قراراتكم الاستراتيجية بمعلومات دقيقة وموثوقة',
      image: 'https://readdy.ai/api/search-image?query=business%20research%20and%20data%20analysis%20with%20reports%20and%20insights%20in%20professional%20office%20with%20clean%20simple%20background&width=600&height=400&seq=service-006&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            خدماتنا
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {t('servicesTitle')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('servicesSubtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative w-full h-56 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-4 right-4 w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-3xl text-blue-600`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <Link 
                  to={`/services/${service.id}`}
                  className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold transition-colors cursor-pointer"
                >
                  {t('viewDetails')}
                  <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link 
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            عرض جميع الخدمات
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}